import request from '@/utils/request'

/**
 * 用户中心API
 */

// 获取个人信息
export function getUserProfile() {
  return request({
    url: '/users/profile',
    method: 'get'
  })
}

// 更新个人信息
export function updateUserProfile(data) {
  return request({
    url: '/users/profile',
    method: 'put',
    data
  })
}

// 获取收藏列表
export function getFavorites(params) {
  return request({
    url: '/users/favorites',
    method: 'get',
    params
  })
}

// 添加收藏
export function addFavorite(productId) {
  return request({
    url: `/users/favorites/${productId}`,
    method: 'post'
  })
}

// 取消收藏
export function removeFavorite(productId) {
  return request({
    url: `/users/favorites/${productId}`,
    method: 'delete'
  })
}

// 获取浏览历史
export function getBrowsingHistory(params) {
  return request({
    url: '/users/browsing-history',
    method: 'get',
    params
  })
}

// 设置支付密码
export function setPaymentPassword(data) {
  return request({
    url: '/users/payment-password',
    method: 'post',
    data
  })
}

// 获取合同列表 (订单列表)
export function getContracts(params) {
  return request({
    url: '/users/contracts',
    method: 'get',
    params
  })
}

// 获取我购买的列表
export function getPurchases(params = {}) {
  return request({
    url: '/Orders',
    method: 'get',
    params: {
      type: 'purchase',
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      status: params.status
    }
  })
}

// 获取我发布的列表
export function getListings(params) {
  return request({
    url: '/users/listings',
    method: 'get',
    params
  })
}

// 获取邀请列表
export function getInvites() {
  return request({
    url: '/users/invites',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/Users/change-password',
    method: 'post',
    data
  })
}

// 上传头像到OSS（使用统一的上传接口）
export function uploadAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('keyPrefix', 'avatar')
  return request({
    url: '/Oss/upload',
    method: 'post',
    data: formData
  })
}

